import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfirmationType, StrakitConfirmationService } from '@ngx-strakit/cdk/components';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmAlertOptions } from '@ngx-strakit/cdk';

/**
 * @deprecated use directly the StrakitConfirmationService instead.
 */
@Injectable({ providedIn: 'root' })
export class IrisConfirmationService extends StrakitConfirmationService {
  private readonly translateService = inject(TranslateService);

  constructor() {
    super();
  }

  public show(
    message?: string,
    confirmBtnText?: string,
    cancelBtnText?: string,
    isHideCloseBtn?: boolean,
    confirmBtnIconClass?: string,
    disableConfirmBtn?: boolean,
    headerTitleText?: string,
    messageInputLabel?: string,
    type: ConfirmationType = 'default',
  ): Promise<boolean | string> {
    return super.show(
      message ? this.translateService.instant(message) : '',
      confirmBtnText ? this.translateService.instant(confirmBtnText) : null,
      cancelBtnText ? this.translateService.instant(cancelBtnText) : null,
      isHideCloseBtn,
      confirmBtnIconClass,
      disableConfirmBtn,
      headerTitleText ? this.translateService.instant(headerTitleText) : null,
      messageInputLabel ? this.translateService.instant(messageInputLabel) : null,
      type,
    );
  }

  public show$(options: ConfirmAlertOptions): Observable<boolean | string> {
    const legacyOptions = {
      message: options?.message ? this.translateService.instant(options.message) : null,
      confirmBtnText: options?.confirmBtnText ? this.translateService.instant(options.confirmBtnText) : null,
      cancelBtnText: options?.cancelBtnText ? this.translateService.instant(options.cancelBtnText) : null,
      headerTitleText: options?.headerTitleText ? this.translateService.instant(options.headerTitleText) : null,
      messageInputLabel: options?.messageInputLabel ? this.translateService.instant(options.messageInputLabel) : null,
    };

    return super.show$({
      ...options,
      ...legacyOptions,
    });
  }
}
